export function turnHiddenOverflow() {
  document.body.style.overflowY = "hidden";
}

export function turnInitialOverflow() {
  document.body.style.overflowY = "scroll";
}
